<div class="col-md-4">
  <div class="col-md-12 location-item">
    <img src={{location.icon}} alt="" />
    <h5>{{location.state}}</h5>
    <svg></svg>
  </div>
</div>
